import theme from '../../theme/theme';

const {
  colors: {
    appBackground,
  },
} = theme;

const styles = {
  footer: {
    width: '100%',
    height: '10vh',
    bottom: '0',
    position: 'absolute',
    background: appBackground,
  },
};

export default styles;
